/**
 * UI-layer helpers for wiring the Linetype property into the property
 * grid.
 *
 * Kept separate from both `standardLinetypes.ts` (pure data) and
 * `PropertyGrid.tsx` (React component). The separation matters
 * because the react-refresh ESLint rule disallows non-component
 * exports from a file that exports React components; keeping these
 * classifiers in their own module lets the PropertyGrid import them
 * without dragging helper exports into the component file.
 */

/**
 * True when the property-grid row label refers to the Linetype
 * property on an entity. The label comes from {@link EntityPreview}'s
 * `editableProperties` list and matches AutoCAD Properties-palette
 * naming verbatim ("Linetype" — not "Line type" or "LTYPE").
 */
export function isLinetypeProperty(label: string): boolean {
  return label === "Linetype";
}

/**
 * AutoCAD hides the Linetype property on Text / MText because text
 * objects do not take a dashed stroke — the glyphs come from the text
 * style's font. Mirror that behaviour: the property-grid cell renders
 * the dropdown for every geometry primitive but falls back to a
 * read-only span on Text / MText.
 */
export function entityAllowsLinetype(entityType: string | null): boolean {
  return entityType !== "Text" && entityType !== "MText";
}
